'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasr';
var iconName = 'stroopwafel';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f551';
var svgPathData = 'M464 256a208 208 0 1 0 -416 0 208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0zm97.6-45.3l22.6 22.6 45.3-45.3c-17-17-28.3-28.3-33.9-33.9l22.6-22.6c5.7 5.7 17 17 33.9 33.9l45.3-45.3c-17-17-28.3-28.3-33.9-33.9l22.6-22.6c5.7 5.7 17 17 33.9 33.9 17-17 28.3-28.3 33.9-33.9l22.6 22.6c-5.7 5.7-17 17-33.9 33.9l45.3 45.3c17-17 28.3-28.3 33.9-33.9l22.6 22.6c-5.7 5.7-17 17-33.9 33.9l45.3 45.3c17-17 28.3-28.3 33.9-33.9l22.6 22.6c-5.7 5.7-17 17-33.9 33.9 17 17 28.3 28.3 33.9 33.9l-22.6 22.6c-5.7-5.7-17-17-33.9-33.9l-45.3 45.3 33.9 33.9-22.6 22.6-33.9-33.9-45.3 45.3c17 17 28.3 28.3 33.9 33.9l-22.6 22.6c-5.7-5.7-17-17-33.9-33.9-17 17-28.3 28.3-33.9 33.9l-22.6-22.6c5.7-5.7 17-17 33.9-33.9l-45.3-45.3c-17 17-28.3 28.3-33.9 33.9l-22.6-22.6c5.7-5.7 17-17 33.9-33.9l-45.3-45.3c-17 17-28.3 28.3-33.9 33.9L63.7 289.9c5.7-5.7 17-17 33.9-33.9-17-17-28.3-28.3-33.9-33.9l22.6-22.6 11.3 11.3zm90.5 0l-45.3 45.3 45.3 45.3 45.3-45.3-45.3-45.3zm113.1-22.6l-45.3-45.3-45.3 45.3 45.3 45.3 45.3-45.3zM369.1 256l-45.3-45.3-45.3 45.3 45.3 45.3 45.3-45.3zM256 278.6l-45.3 45.3 45.3 45.3 45.3-45.3-45.3-45.3z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faStroopwafel = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;